<template>
	<div class="wd-container top" @click="gotomain">
		<el-row type="flex" justify="start" class="search ">
			<div class="logo"><el-image  v-if="!$weidajs.isEmpty(logininfo.companyinfo.logo)" :src="$wdpicurl(logininfo.companyinfo.logo)" fit="contain" class="logoimg"></el-image></div>
			<div class="wd-m-l-50 wd-font-26">{{titletext}}</div>
		</el-row>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'Top2',
	computed: {
		...mapState(['logininfo'])
	},
	props:{
		titletext:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			companyname: '威达软件',
			companyurl: 'http://www.weida888.com',
			logourl: require('@/assets/logo.png')
		};
	},
	methods: {
		handleSelect(type) {
			console.log('a');
			if (type === 'login') {
				this.$router.push('/login');
			}
		},
		gotomain(){
			this.$router.push('/');
		}
	}
};
</script>

<style lang="scss" scoped>
.top {
	height: 120px;
	line-height: 120px;
	font-size: 12px;
	color: #666666;
	.search {
		.logo {
			width: 120px;
			height: 120px;
			.logoimg {
				margin-top: 10px;
				width: 100px;
				height: 100px;
			}
		}
	}
}
</style>
